import { Button, ItemCard } from '../../components';

import { ButtonVariantEnum } from '../../enums';
import { FaAngleRight } from 'react-icons/fa';
import { FunctionComponent } from 'react';
import { GruposEleitoresCardItemType } from '../../types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GruposEleitoresCardItem: FunctionComponent<GruposEleitoresCardItemType> = ({
  icon,
  tipoDescricao,
  totalEleitoresUnicos = 0,
  totalEleitores = 0,
  linkGerenciamentoEleitores,
  permiteAlterarDadosEleicao,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ItemCard
      Icon={icon}
      muted={totalEleitores <= 0}
      footer={
        permiteAlterarDadosEleicao && (
          <Button
            className="justify-content-end py-1"
            title={t('label.gerenciar')}
            variant={ButtonVariantEnum.LINK}
            onClick={() => navigate(linkGerenciamentoEleitores)}
          >
            {t('label.gerenciar')} <FaAngleRight size={'1.25rem'} />
          </Button>
        )
      }
    >
      <div className={'d-flex flex-column align-items-end'}>
        <div>
          <span className="fs-1" title={t('texto.total_eleitores_validos')}>
            {totalEleitoresUnicos}
          </span>
          <small className="fs-6 text-muted" title={t('texto.total_eleitores')}>
            / {totalEleitores}
          </small>
        </div>

        <div className="fw-bold text-end">{tipoDescricao}</div>
      </div>
    </ItemCard>
  );
};

export default GruposEleitoresCardItem;
